import React from "react";

import ConnecteableObject from "../models/Channel";
import ConnectorGrab from "../components/ConnectorGrab";
import Page from "../models/Page";
import { ConnectionType, dehighlightConnections, highlightConnections } from "../models/Connection";
import ConnectionTarget from "./ConnectionTarget";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import Actor from "../models/Actor";
import { PagePrintInfo } from "../models/PagePrintInfo";
import { channelTypeInfo } from "../models/ChannelType";
import type Room from "../models/Room";
export default function ActorChannelView(props: {
  page: Page;
  fixed: boolean;
  channel: ConnecteableObject;
  maxWidth: number;
  print?: PagePrintInfo;
  showAllChannels: boolean;
}) {
  const { channel, page, fixed, maxWidth, print, showAllChannels } = props;
  // const lastSelected = useRef<boolean>(false);
  var compact = 0;
  let actor = channel.parent as Actor;
  useOnChangeWatcher(channel, (changedProperty, changedObject) => {
    console.log("update channel", changedProperty);
    page.updateConnections();
    return true;
  });

  useOnChangeWatcher(page);

  var isConnected = channel.isConnected(ConnectionType.Channel);
  var consumer = channel.getConnectedConsumer();

  if (actor.selected || showAllChannels) {
    compact = 2;
  } else {
    compact = 1;
  }

  var compactName = channel.tag3;

  var targetChannel: any = null;

  var style: any = { cursor: print ? "default" : "pointer" }; // no itx
  let consumerIsOnThisPage = false;

  if (isConnected) {
    if (page.isFloorPlan) {
      if (consumer?.parent?.className == "Room") {
        consumerIsOnThisPage = (consumer.parent as Room).isVisibleInFloorPlan;
      } else {
        consumerIsOnThisPage = consumer?.parent?.parent == page.parentFloor;
      }
    } else {
      consumerIsOnThisPage = consumer?.parent == page.parentRoom;
    }

    // define the Backgroundcolor via used: on this page, on another page or open to use
    if (consumerIsOnThisPage) {
      style.backgroundColor = "var(--defaultBackgroundColor)";
      // compactName += `: ${consumer?.tagOrName}`;
    } else {
      style.backgroundColor = "var(--backgroundColorGrey)";
      if (channel.selected || (channel.parent as Actor)?.selected) {
        // while selected show where used

        // if (consumer) {
        //   compactName += ": " + consumer.fullTag;
        // }

        targetChannel = // this is  the consumer target
          (
            <div
              style={{
                position: "absolute",
                left: "100%",
                whiteSpace: "nowrap",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  position: "relative",
                  height: "1px",
                  width: "25px",
                  marginTop: "9px",
                  backgroundColor: "var(--connectionColorChannel)",
                }}
              />
              <div style={{ backgroundColor: "white", padding: "5px", marginTop: "-5px" }}>
                {consumer?.fullTag}&nbsp; {consumer?.name}
              </div>
              &nbsp;
            </div>
          );
      }

      //compactName += `: ${consumer?.parent?.tagOrName}.${consumer?.tagOrName}`;
    }

    if (channel.hasErrors || (!channel.knxChannel && actor.template)) {
      style.backgroundColor = "var(--error-color)";
      compactName = "";
    }
  }
  if (channel.selected) {
    compact = 2;
    style.backgroundColor = "var(--selectedOrange)";
  }

  let errorText: string | undefined = undefined;
  if (channel.errors?.noMatchingKNXChannel) {
    errorText = `"${actor?.template?.name}" hat keinen Kanal frei vom Type: ${state.translate(
      `channelType.${channel.channelType}`,
      channel.channelType,
    )}`;
    compactName = "";
  } else if (channel.errors?.channelDeletedButConnected) {
    errorText = "Der Kanal wurde gelöscht";
    compactName = "";
  }

  return (
    <ConnectionTarget
      className="channel"
      page={page}
      target={channel}
      compact={compact}
      connectionType={ConnectionType.Channel}
      print={print}
    >
      {targetChannel}

      <div
        className="channelContentWrapper"
        data-tooltip-id={errorText ? "tv-tooltip" : undefined}
        data-tooltip-content={errorText}
        data-tooltip-place="right"
        data-tooltip-variant="error"
        onMouseEnter={(ev) => {
          if (print == undefined && ev.buttons == 0) {
            highlightConnections(true, page, channel);
          }
        }}
        onMouseLeave={(ev) => {
          if (print == undefined && ev.buttons == 0) {
            dehighlightConnections(true, page, channel);
          }
        }}
      >
        <div
          className="channelContent hoverable"
          style={style}
          onClick={(ev) => {
            if (print == undefined) {
              state.selectionManager.selectedObject = channel;
              page.resetIsNewOnAllConnections();
              ev.stopPropagation();
            }
          }}
        >
          <div
            style={{
              position: "absolute",
              left: "100%",
              top: "0px",
              width: "40px",
              height: "100%",
              backgroundColor: "trasparent",
            }}
          ></div>

          {!isConnected && compact == 2 && channelTypeInfo(channel.channelType).canBeConnectedWithPartner == true && (
            <ConnectorGrab
              mainPage={page}
              page={page}
              connectableObject={channel}
              x={100}
              portName=""
              ownerSelected={false}
              type={ConnectionType.Channel}
              disabled={print != undefined}
            />
          )}
          <div
            style={{
              overflow: "hidden",
              display: "inline-block",
              maxWidth: `${maxWidth}px`,
              wordWrap: "normal",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              textAlign: "left",
              width: "100%",
              paddingLeft: "5px",
            }}
          >
            {compact == 2 && compactName}
          </div>
        </div>
      </div>

      <div
        style={{
          position: "absolute",
          height: "2px",
          width: fixed ? "10px" : "0px",
          opacity: 0.3,
          backgroundColor: "var(--connectionColorChannel)",
          left: "100%",
          top: "9px",
        }}
      >
        <div
          className="portR"
          style={{ position: "absolute", top: "1px", left: "100%", width: "0px", height: "0px" }}
        ></div>
      </div>
    </ConnectionTarget>
  );
}
